<section *ngIf="packageData?.discounts" class="rounded-xl shadow-full border border-greyLight py-9 px-6 md:px-16 w-full">
  <h2 class="text-2xl font-bold" transloco="profile-vn.billing.multi-month.title"></h2>
  <span class="text-sm" transloco="profile-vn.billing.multi-month.subtitle"></span>

  <article class="max-w-screen-sm">

    <app-month-selection 
    [selectedDuration]="selectedDuration" 
    [currentActiveDuration]="currentActiveDuration"
    [packageData]="packageData"
      (durationSelected)="onDurationSelected($event)" />

    <ul class="text-grey">
      <li class="flex items-center py-4 text-2xl text-black font-medium border-b border-greyDark">
        <span class="flex flex-1" transloco="payment.summary.total"></span>
        @if (packageData?.discounts && selectedDuration > 1) {
        <span class="text-sm text-orange font-semibold px-2">
          ({{selectedDuration + ' months' }})
        </span>
        }
        <span>{{ totalPrice() | currency }}</span>

      </li>
    </ul>
    <p class="text-grey text-xs text-end py-2" transloco="payment.summary.price-taxes"></p>

    <div class="text-orange text-sm py-6">
      <p class="" transloco="profile-vn.billing.multi-month.info"></p>
      <p>
        {{ 'profile-vn.billing.multi-month.last-payment' | transloco : {
        date: packageData?.billingCycleInfo.lastPaymentDate
        }
        }}
      </p>
      <p>
        {{
        'profile-vn.billing.multi-month.next-charge' | transloco : {
        amount: totalPrice() | number:'1.2-2',
        date: packageData?.billingCycleInfo.nextPaymentDate }
        }}
      </p>
      <p> {{ 'profile-vn.billing.multi-month.info-2' | transloco : {
        duration: selectedDuration,
        unit: selectedDuration > 1
        ? ('profile-vn.months' | transloco)
        : ('profile-vn.month' | transloco)
        }
        }}</p>

      <!-- <p class="">
        <span transloco="profile-vn.billing.multi-month.last-payment"></span>
        <strong> {{ packageData?.billingCycleInfo.lastPaymentDate }}</strong>
      </p>
      <p class="">
        <span transloco="profile-vn.billing.multi-month.next-charge"></span>
        <strong> ${{ totalPrice() }} </strong>
        <span transloco="profile-vn.on"></span>
        <strong> {{ packageData?.billingCycleInfo.nextPaymentDate }}</strong>
      </p>
      <p class="">
        <span transloco="profile-vn.billing.multi-month.info-2"></span>
        <strong> {{ selectedDuration }} </strong>
        @if (selectedDuration > 1) {
          <span transloco="profile-vn.months"></span>
        } @else {
          <span transloco="profile-vn.month"></span>
        }
      </p> -->
    </div>
    <div>
      <button type="button" (click)="onContinue()" [disabled]="selectedDuration === currentActiveDuration"
        class="flex items-center justify-center bg-orange text-white font-semibold w-full sm:w-fit px-10 sm:px-16 py-3 rounded-xl hover:scale-105 active:scale-min transition-all disabled:opacity-20 disabled:cursor-not-allowed">
        <span transloco="btn-vn.continue"></span>
        <img src="/images/icons/arrow-icon.svg" alt="white arrow" class="w-[1.8rem] pb-1 h-fit rtl:-scale-x-100">
      </button>
    </div>
  </article>
</section>